<div class="search-page">
  <vw-page
    [page]="page"
    [alwaysFillNav]="true"
    *ngIf="page"
    [showDealerInformation]="true"
  >
    <vw-page-header>
      <div breadcrumbs>
        <vw-breadcrumbs [currentPage]="'search' | translate"></vw-breadcrumbs>
      </div>
      <div class="row" header>
        <div class="col-12 col-sm-6 mx-auto">
          <div class="search-form">
            <form [formGroup]="searchForm" (ngSubmit)="formSubmit()">
              <vw-text-box
                [label]="'searchPage.searchProduct' | translate"
                placeholder="{{ 'searchPage.placeholder' | translate }}"
                [parentForm]="searchForm"
                [id]="'searchValue'"
                [type]="'text'"
                [formControlProp]="'query'"
                [buttonDisabled]="false"
                [buttonText]="'search' | translate"
                (buttonClick$)="formSubmit()"
              ></vw-text-box>
            </form>
          </div>
        </div>
      </div>
    </vw-page-header>

    <ng-container *ngIf="submittedSearchValue">
      <div class="container my-5">
        <div class="row mt-4" *ngIf="numberOfProductIDs">
          <div class="col-12">
            <div class="text-center">
              <span>{{
                "searchPage.numberOfSearchResults"
                  | translate: { number: numberOfProductIDs }
              }}</span>
            </div>
          </div>
        </div>

        <div class="row mt-4 mb-1">
          <div class="col-md-12">
            <div class="text-center">
              <span class="search-page-value h2 fw-light">
                "{{ submittedSearchValue }}"
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-12 col-xl-10 mx-auto">
            <div class="d-flex flex-row-reverse">
              <vw-sorting-select
                (valueChanged$)="sortChanged($event)"
              ></vw-sorting-select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-xl-10 mx-auto">
            <vw-product-list
              [query]="submittedSearchValue"
              [noProductsMessage]="'searchPage.noProducts' | translate"
              (reportNumberOfProductIDs$)="reportNumberOfProductIDs($event)"
              [logSearch]="true"
            ></vw-product-list>
          </div>
        </div>
      </div>
    </ng-container>

    <vw-popular-products> </vw-popular-products>
  </vw-page>
</div>
